module.exports = __webpack_public_path__ + "static/media/dinosaur(20).dfedc8bc.PNG";